import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const LockOpenSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor">
      <path
        d="M6.25 10V6.667c0-3.13 2.542-5.417 5.75-5.417 1.373 0 2.626.415 3.613 1.147a.75.75 0 0 1-.894 1.206c-.715-.53-1.65-.853-2.719-.853-2.481 0-4.25 1.714-4.25 3.917V10a.75.75 0 0 1-1.5 0"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fillRule="evenodd"
        d="M19 9.5a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 21V11A1.5 1.5 0 0 1 5 9.5zm-7 4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5"
        clipRule="evenodd"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(LockOpenSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
